import styled, { css } from 'styled-components';

import { mediaDown, rem } from 'approot/shared/style';
import {
  spacing12,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import { Row, Col } from 'approot/shared/grid/grid';
import { ContentCardWrapper } from 'approot/shared/content-card/content-card.styles';

type ContentCardRowProps = {
  carouselOnSmall?: boolean;
};

export const ContentCardRow = styled(Row).attrs({
  as: 'ul',
})<ContentCardRowProps>`
  list-style: none;
  margin-bottom: 0;
  padding: 0;

  ${({ carouselOnSmall }) =>
    carouselOnSmall &&
    css`
      ${mediaDown.xs`
        margin-left: -${rem(spacing12)};
        margin-right: -${rem(spacing12)};
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-snap-type: x mandatory;
        padding: ${rem(2)} ${rem(spacing16)};
        -webkit-overflow-scrolling: touch;

        &:after {
          content: '';
          padding: ${rem(spacing16)};
        }

        li {
          flex: 0 0 100%;
          scroll-snap-align: center;
        }
      `};
    `}
`;

export const ContentCardCol = styled(Col).attrs({
  as: 'li',
  sm: 6,
  md: 4,
  lg: 3,
})`
  margin-bottom: ${rem(spacing24)};

  ${ContentCardWrapper} {
    height: 100%;
  }
`;

export const ContentCardColThirds = styled(Col).attrs({
  as: 'li',
  sm: 6,
  md: 4,
})`
  margin-bottom: ${rem(spacing24)};

  ${ContentCardWrapper} {
    height: 100%;
  }
`;
